import script from "./workload-view-summary-configurations.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-view-summary-configurations.vue?vue&type=script&setup=true&lang=ts"

import "./workload-view-summary-configurations.vue?vue&type=style&index=0&id=cb927fc6&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb927fc6"]])

export default __exports__